import i18n from '../i18n';
import { useEffect } from 'react';
import { notification } from 'antd';

let notificationApi = null;

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    notificationApi = api;
    return () => {
      notificationApi = null;
    };
  }, [api]);

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};

const config = { placement: 'top', closable: false, duration: 3 };

const showNotification = (type, title, description) => {
  if (!notificationApi) return;

  notificationApi[type]({
    title,
    description,
    ...config,
  });
};

const notifyWarning = (message, description) =>
  showNotification('warning', message && i18n.t(message), description);

const UtilNotify = {
  notifySuccess: (message, description) => {
    showNotification('success', message && i18n.t(message), description);
  },
  notifyError: (message, description) => {
    showNotification('error', message && i18n.t(message), description);
  },
  notifyErrorServer: (message, description) => {
    if (message) {
      if (message.startsWith('Duplicate entry')) {
      } else if (message.startsWith('There is no Account with this email')) {
        message = 'WARNNING_THERE_IS_NO_ACCOUNT';
      } else if (
        message.startsWith(
          'Invalid value, Invalid value, saveData.email field is required and cannot be empty & Must be valid email'
        )
      ) {
        message = 'WARNNING_EMAIL_REQUIRED_VALID';
      } else if (message.startsWith('check your password and try again')) {
        message = 'WARNNING_INCORRECT_LOGIN_OR_PASSWORD';
      }
      message = i18n.t(message);
    }
    showNotification('error', message || 'Error', description);
  },
  notifyInfo: (message, description) => {
    showNotification('info', message && i18n.t(message), description);
  },
  notifyWarning,
  notifywarning: notifyWarning,
  notifyText: (message, description) =>
    showNotification('info', message && i18n.t(message), description),
};

export default UtilNotify;
